module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("菜单名称")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menu.name),
      expression: "menu.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.menu.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menu, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("菜单类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menu.type),
      expression: "menu.type"
    }],
    staticClass: "form-control m-b",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.menu, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menu.TypeList), function(type) {
    return _c('option', {
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0)])])]), _vm._v(" "), (_vm.menu.type === 'ARTICLE' || _vm.menu.type === 'PERSON' || _vm.menu.type === 'SCENERY' || _vm.menu.type === 'PARENT') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("访问地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menu.location),
      expression: "menu.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.menu.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menu, "location", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'ARTICLE') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("关联文章")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ArticlePagerSelection', {
    attrs: {
      "activeArticle": _vm.menu.article
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'PERSON') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("关联人物")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('PersonPagerSelection', {
    attrs: {
      "activePerson": _vm.menu.person
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'URL') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("菜单链接")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.menu.url),
      expression: "menu.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.menu.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.menu, "url", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'TOPIC') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("关联专题")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('TopicPagerSelection', {
    attrs: {
      "activeTopic": _vm.menu.topic
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.menu.type === 'SCENERY') ? _c('div', {
    staticClass: "col-xs-12 mt10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-md-2 control-label mt5"
  }, [_vm._v("关联定制页面")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('SceneryPagerSelection', {
    attrs: {
      "activeScenery": _vm.menu.scenery
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu.errorMessage),
      expression: "menu.errorMessage"
    }],
    staticClass: "alert alert-danger mt10 mb0"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.menu.errorMessage) + "\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5fadabec"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/topic/widget/PanelBody.vue
// module id = 991
// module chunks = 1